import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'clsx';

import style from './collapsible-list-section-header.module.css';

import type { FC } from 'react';

type CollapsibleListCaretProps = {
  /** Controls whether the caret is displayed */
  active?: boolean;

  className?: string;

  /** Controls the rotation state of the caret */
  open?: boolean;

  /** Controls vertical orientation of the caret */
  openCloseCaretVertical?: boolean;
};

export const CollapsibleListCaret: FC<CollapsibleListCaretProps> = ({ active, className, openCloseCaretVertical = false, open }) => {
  if (active) {
    return (
      <div
        className={classnames(
          style['open-chevron'],
          'collapsible-list-caret',
          {
            [style.vertical]: openCloseCaretVertical,
            [style.open]: open,
          },
          className,
        )}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    );
  }
  return null;
};
